jQuery(document).ready(function ($) {
  var $relatedProducts = $(".related-products");

  if ($relatedProducts.length) { 
    var element_position = $relatedProducts.offset().top;

    $(window).on("scroll", function () {
      if (!$(".related-products-slider").hasClass("slick-initialized")) {
        $(".related-products-slider").slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 1500,
          infinite: true, // Fixed typo (infinite instead of infinte)
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 567,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }
    });
  }
});



jQuery(document).ready(function () {

  
  jQuery("div.tmenu-watermark.tmenu_item_link").remove();
  jQuery(document).on(
    "mouseenter",
    ".tmenu_item.tmenu_item--root",
    function () {
      jQuery("div.tmenu-watermark.tmenu_item_link").remove();
      setTimeout(function () {
        jQuery("div.tmenu-watermark.tmenu_item_link").remove();
      }, 300);
    }
  );

  let testimonialsToShow = 3; // Number of testimonials to show initially
  const $testimonials = $(".client-item");
  const $loadMoreBtn = $(".load-more");
  const totalTestimonials = $testimonials.length;

  // Initially show only the first 3 testimonials
  $testimonials.hide().slice(0, testimonialsToShow).show();

  // Hide the Load More button if there are 3 or fewer testimonials
  if (totalTestimonials <= testimonialsToShow) {
    $loadMoreBtn.hide();
  }

  $loadMoreBtn.on("click", function (e) {
    e.preventDefault();

    // Show next 3 testimonials
    testimonialsToShow += 3;
    $testimonials.slice(0, testimonialsToShow).slideDown();

    // Hide the Load More button if all testimonials are shown
    if (testimonialsToShow >= totalTestimonials) {
      $loadMoreBtn.hide();
    }
  });

  // 
  $('.category-items-carousel').owlCarousel({
      items: 4.4,
      loop: true,
      margin: 20,
      dots: false,
      nav: true,
      autoplay: 0,
      autoHeight: true,
      autoplayTimeout: 8000,
      autoplaySpeed: 3000,
      smartSpeed: 800,
      responsive: {
        0: { items: 1 },
        480: { items: 1 },
        767: { items: 2 },
        991: { items: 3 },
        1199: { items: 4.4 }
      }
    });

});

jQuery(".faq-item-title").on("click", function () {
  jQuery(this).hasClass("active")
    ? (jQuery(this).removeClass("active"),
      jQuery(this).siblings(".faq-title-content").slideUp(200))
    : (jQuery(".faq-item-title").removeClass("active"),
      jQuery(this).addClass("active"),
      jQuery(".faq-title-content").slideUp(200),
      jQuery(this).siblings(".faq-title-content").slideDown(200));
});

// Show the first tab and hide the rest
$(".tabs-nav li:first-child").addClass("active");
$(".tab-content").hide();
$(".tab-content:first").show();

// Click function
$(".tabs-nav li").click(function () {
  $(".tabs-nav li").removeClass("active");
  $(this).addClass("active");
  $(".tab-content").hide();

  var activeTab = $(this).find("a").attr("href");
  $(activeTab).fadeIn();
  return false;
});


// $(document).ready(function () {
//     $('select').each(function () {
//         var $select = $(this);
//         var selectName = $select.attr('name'); // Get the name of the select
//         var selectID = $select.attr('id');
//         var $wrapper = $('<div class="radio-wrapper"></div>'); // Create a wrapper for radio buttons

//         // Loop through each option inside the select
//         $select.find('option').each(function () {
//             var value = $(this).val();
//             var label = $(this).text();
//             var isSelected = $(this).is(':selected'); // Check if it's selected

//             if (value) { // Ignore empty values
//                 var radioID = selectID + '-' + value; // Unique ID for each radio button

//                 // Create a radio button
//                 var $radio = $(`
//                     <label for="${radioID}" class="radio-label">
//                         <input type="radio" name="${selectName}" id="${radioID}" value="${value}" ${isSelected ? 'checked' : ''}>
//                         ${label}
//                     </label>
//                 `);

//                 $wrapper.append($radio);
//             }
//         });

//         // Replace the select dropdown with radio buttons
//         $select.after($wrapper).hide();
//     });

//     // Update the original select field when a radio button is clicked
//     $(document).on('change', '.radio-wrapper input[type="radio"]', function () {
//         var selectedValue = $(this).val();
//         var selectName = $(this).attr('name');
        
//         $('select[name="' + selectName + '"]').val(selectedValue).trigger('change');
//     });
// });



document.addEventListener("DOMContentLoaded", function () {


document.referrer && localStorage.setItem("lastPage", document.referrer);

document.getElementById("continue-shopping-btn").addEventListener("click", function () {
    const lastPage = localStorage.getItem("lastPage") || "/";
    window.location.href = lastPage;
});  


    document.body.addEventListener("click", function (event) {
        let addToCartButton = event.target.closest(".spf-product__form-btn-addtocart");

        // let addToCartButtonNew =  event.target.closest(".product-form__submit.backorder");
      
        // if (addToCartButtonNew) {
        // // Show confirmation popup
              

        //   document.querySelector(".backorder-popup").classList.add("show");

        //   document.querySelector(".continue-btn-backorder").addEventListener("click", function () {
        //     document.querySelector(".backorder-popup").classList.remove("show");
        //   });   
              
        //   }

        if (addToCartButton) {
            event.preventDefault(); // 

            

            let form = addToCartButton.closest("form");
            if (!form) {
               
                return;
            }

            let formData = new FormData(form);

            //  AJAX request to add product to cart
            fetch("/cart/add.js", {
                method: "POST",
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                // Fetch updated Cart Drawer & Cart Icon
                return fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
            })
            .then(response => response.json())
            .then(data => {

                // Replace Entire Cart Drawer
                let newCartDrawer = new DOMParser()
                    .parseFromString(data["cart-drawer"], "text/html")
                    .querySelector("cart-drawer");

                let oldCartDrawer = document.querySelector("cart-drawer");
                if (newCartDrawer && oldCartDrawer) {
                    oldCartDrawer.replaceWith(newCartDrawer);
                    

                    // Reopen the cart drawer after updating
                    setTimeout(() => {
                        newCartDrawer.classList.add("active");
                    }, 300);
                } else {
                    console.warn("Cart Drawer update failed!");
                }

                // update Cart Icon Bubble
                let cartIconElement = document.querySelector("#cart-icon-bubble");
                if (cartIconElement && data["cart-icon-bubble"]) {
                    cartIconElement.innerHTML = data["cart-icon-bubble"];
                    
                } else {
                    console.warn("Cart Icon update failed!");
                }
            })
            .catch(error => console.error("Error updating Cart Drawer:", error));
        } 
    });
});



document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (event) {
        let addToCartButton = event.target.closest("#gfqv-btn");

        if (addToCartButton) {
            event.preventDefault(); // 
           

         

            let form = addToCartButton.closest("form");
            if (!form) {
               
                return;
            }

            let formData = new FormData(form);

            //  AJAX request to add product to cart
            fetch("/cart/add.js", {
                method: "POST",
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                // Fetch updated Cart Drawer & Cart Icon
                return fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
            })
            .then(response => response.json())
            .then(data => {

                // Replace Entire Cart Drawer
                let newCartDrawer = new DOMParser()
                    .parseFromString(data["cart-drawer"], "text/html")
                    .querySelector("cart-drawer");

                let oldCartDrawer = document.querySelector("cart-drawer");
                if (newCartDrawer && oldCartDrawer) {
                    oldCartDrawer.replaceWith(newCartDrawer);


                   // hide the pop up
                  const productPopUp = document.getElementById("gfqv-modal");
                  
                  // Hide the div
                  if (productPopUp) {
                      productPopUp.style.display = "none";
                  }
                    

                    // Reopen the cart drawer after updating
                    setTimeout(() => {
                        newCartDrawer.classList.add("active");
                    }, 300);
                } else {
                    console.warn("Cart Drawer update failed!");
                }

                // update Cart Icon Bubble
                let cartIconElement = document.querySelector("#cart-icon-bubble");
                if (cartIconElement && data["cart-icon-bubble"]) {
                    cartIconElement.innerHTML = data["cart-icon-bubble"];
                    
                } else {
                    console.warn("Cart Icon update failed!");
                }
            })
            .catch(error => console.error("Error updating Cart Drawer:", error));
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {

  
    //const img = document.querySelector(".size-chart-image img");

    const images = document.querySelectorAll(".size-chart-image img, .size-chart-image img.spec-image ");

    //if (img) {
      images.forEach(img => {
        img.addEventListener("click", function () {
            // Create fullscreen container
            const fullscreenContainer = document.createElement("div");
            fullscreenContainer.classList.add("fullscreen-container");

            // Create image element
            const fullscreenImg = document.createElement("img");
            fullscreenImg.src = img.src;
            fullscreenImg.classList.add("fullscreen-img");

            // Create close button
            const closeButton = document.createElement("button");
            closeButton.innerHTML = "✖"; // "X" symbol
            closeButton.classList.add("close-button");

            // Append elements to container
            fullscreenContainer.appendChild(fullscreenImg);
            fullscreenContainer.appendChild(closeButton);
            document.body.appendChild(fullscreenContainer);

            // Close on clicking the "X" button or background
            closeButton.addEventListener("click", function () {
                document.body.removeChild(fullscreenContainer);
            });

            fullscreenContainer.addEventListener("click", function (e) {
                if (e.target === fullscreenContainer) {
                    document.body.removeChild(fullscreenContainer);
                }
            });
        });
     });
});

// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".product-item").forEach((product) => {
//         let productId = product.getAttribute("data-product-id");
//         let variantCount = product.getAttribute("data-variant-count"); // Ensure this data is available in the product item.

//         if (variantCount && parseInt(variantCount) > 1) {
//             // Find and remove "Add to Cart" button
//             let addToCartBtn = product.querySelector(".add-to-cart");
//             if (addToCartBtn) addToCartBtn.remove();

//             // Create the 'Choose Options' button
//             let quickAddDiv = document.createElement("div");
//             quickAddDiv.className = "quick-add no-js-hidden";
//             quickAddDiv.innerHTML = `
//                 <modal-opener data-modal="#QuickAdd-${productId}">
//                     <button id="quick-add-${productId}-submit" type="button"
//                         class="quick-add__submit button button--full-width button--secondary"
//                         aria-haspopup="dialog"
//                         data-product-url="/products/${productId}">
//                         Choose options
//                     </button>
//                 </modal-opener>
//             `;

//             // Append to product container
//             product.appendChild(quickAddDiv);
//         }
//     });
// });

document.addEventListener("DOMContentLoaded", function () {
    // Select the parent element where dynamic <a> tags are added
    const parentElement = document.body; // Update this to a more specific parent if needed

    const observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    const elements = node.querySelectorAll(".open-quick-view");
                    elements.forEach(function (element) {
                        // Remove the SVG inside the <a> tag
                        const svg = element.querySelector("svg");
                        if (svg) {
                            svg.remove();
                        }
                        // Add the text "Quick view" inside the <a> tag
                        element.textContent = "Quick view";
                    });
                }
                // Handle direct nodes with the target class
                if (node.matches && node.matches(".open-quick-view")) {
                    const svg = node.querySelector("svg");
                    if (svg) {
                        svg.remove();
                    }
                    node.textContent = "Quick view";
                }
            });
        });
    });

    // Start observing for changes in the parent element
    observer.observe(parentElement, { childList: true, subtree: true });
});


const targetNode = document.querySelector('.cart-drawer'); 

const observerCart = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
              if (document.querySelector('.knives_checkbox_wrapper')) {
                  const agreeCheckboxes = document.querySelectorAll('.agree-checkbox');
                  const elementExists = document.querySelectorAll(".knives_checkbox_wrapper");
                  
                  const checkoutButtons = document.querySelectorAll('.cart__checkout-button');
                  checkoutButtons.forEach(checkoutButton => checkoutButton.disabled = true);

                  agreeCheckboxes.forEach(agreeCheckbox => {
                  agreeCheckbox.addEventListener('change', function () {
                    
                    let _this = this;
                    checkoutButtons.forEach(checkoutButton => checkoutButton.disabled = !_this.checked);
                  });
                });
              }
          });
      });
      
// Observe changes to the body (or any other parent container)
observerCart.observe(targetNode, { childList: true, subtree: true });


